import { io } from 'socket.io-client';
export { NodeWebSocket, Fetch } from 'socket.io-client';
export const createSocket = io;
//# sourceMappingURL=Socket.js.map